export const DEMO_REPORTS = [
  {
    id: 1,
    company: 'TechStart Inc.',
    startDate: '2025-09-01',
    endDate: '2025-09-30',
    externalEfforts: 'Social media campaign, email newsletter',
    createdAt: '2025-10-01T10:00:00Z',
    updatedAt: '2025-10-01T10:00:00Z',
    metrics: {
      totalPlacements: 5,
      tier1Placements: 2,
      tier2Placements: 3,
      totalReach: 1250000,
      domainAuthority: 85,
    },
  },
  {
    id: 2,
    company: 'GreenTech Solutions',
    startDate: '2025-08-01',
    endDate: '2025-08-31',
    externalEfforts: 'Product launch event, influencer partnerships',
    createdAt: '2025-09-05T14:30:00Z',
    updatedAt: '2025-09-05T14:30:00Z',
    metrics: {
      totalPlacements: 8,
      tier1Placements: 3,
      tier2Placements: 5,
      totalReach: 2100000,
      domainAuthority: 90,
    },
  },
  {
    id: 3,
    company: 'HealthPlus Medical',
    startDate: '2025-07-01',
    endDate: '2025-07-31',
    externalEfforts: 'Webinar series, thought leadership content',
    createdAt: '2025-08-02T09:15:00Z',
    updatedAt: '2025-08-02T09:15:00Z',
    metrics: {
      totalPlacements: 6,
      tier1Placements: 1,
      tier2Placements: 5,
      totalReach: 980000,
      domainAuthority: 78,
    },
  },
  {
    id: 4,
    company: 'seoplus+',
    startDate: '2025-10-01',
    endDate: '2025-10-31',
    externalEfforts: 'Conference speaking, podcast appearances',
    createdAt: '2025-10-26T11:00:00Z',
    updatedAt: '2025-10-26T11:00:00Z',
    metrics: {
      totalPlacements: 12,
      tier1Placements: 4,
      tier2Placements: 8,
      totalReach: 3500000,
      domainAuthority: 95,
    },
  },
];

export const DEMO_REPORT_DETAILS = {
  1: {
    id: 1,
    company: 'TechStart Inc.',
    startDate: '2025-09-01',
    endDate: '2025-09-30',
    externalEfforts: 'Social media campaign, email newsletter',
    createdAt: '2025-10-01T10:00:00Z',
    updatedAt: '2025-10-01T10:00:00Z',
    placements: [
      {
        id: 1,
        mediaOutlet: 'TechCrunch',
        title: 'Innovative Tech Startups to Watch',
        url: 'https://techcrunch.com/techstart-feature',
        publishedDate: '2025-09-15',
        expertName: 'Brock Murray',
        tier: 'tier1',
      },
      {
        id: 2,
        mediaOutlet: 'Forbes',
        title: 'Digital Transformation Leaders',
        url: 'https://forbes.com/digital-transformation',
        publishedDate: '2025-09-22',
        expertName: 'Brock Murray',
        tier: 'tier1',
      },
    ],
    metrics: {
      totalPlacements: 5,
      tier1Placements: 2,
      tier2Placements: 3,
      totalReach: 1250000,
      domainAuthority: 85,
    },
  },
};

export const DEMO_REPORT_NOTES = [
  {
    id: 1,
    reportID: 1,
    userID: 1,
    userType: 0,
    content: 'Great month for TechStart! Exceeded placement goals.',
    createdAt: '2025-10-01T15:30:00Z',
    updatedAt: '2025-10-01T15:30:00Z',
  },
  {
    id: 2,
    reportID: 1,
    userID: 1,
    userType: 0,
    content: 'Client is very happy with Forbes placement.',
    createdAt: '2025-10-02T09:45:00Z',
    updatedAt: '2025-10-02T09:45:00Z',
  },
];
